// FLAGS: none
// App as a lazy chunk, so nothing of it evaluates before the boot sequence has initialised i18n, wrapped in the
// one thing the chunk cannot provide for itself: the boundary that catches its failure to load. The static boot
// loader is not removed here - App takes it down once its own session bootstrap settles, so the two spinners
// never swap (see App.tsx).
import { lazy, Suspense } from "react";
import BootErrorBoundary from "@src/boot/BootErrorBoundary";

const App = lazy(() => import("@src/App"));

const LazyApp = () => (
  <BootErrorBoundary>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </BootErrorBoundary>
);

export default LazyApp;
